import { getUserToken } from "./user";
import WebKeys from "./WebKeys";

// TODO : 1. Mirar de pasar de $.ajax a axios 2. pasar a async

/**
 * Definicion de la variable `Ims.rootpath` presente en todas las páginas
 * para tener la url absoluta del contexto.
 * Se utiliza para simplificar el uso de urls relativas en todas las llamadas
 * ajax independientemente de si la página web esta bajo un subpath o no.
 *
 * Nota:
 * Como ahora todas las páginas están en la raíz lo mismo ya no sería necesario.
 */
declare let ImsRootPath: string | undefined;

/**
 * Realiza una petición ajax según la configuración indicada.
 *
 * La url indicada en la configuración debe ser relativa, ya que este método
 * añadira la parte del contexto automáticamente.
 *
 * Si no se indica lo contrario en la configuración, la petición se realizará
 * de forma asíncrona utilizando el método POST.
 *
 * En caso de que exista información de un usuario registrado, entonces se
 * enviará también la cabecera de autenticación correspondiente.
 *
 * @param ajaxSettings la configuración de la petición
 */
export function send(ajaxSettings: JQueryAjaxSettings): void {
  const cfg = { method: "POST", ...ajaxSettings };

  /* ImsRootPath debería estar definidia globalmente en el html de la página.
   * Debería: por lo que es mejor verificar que realmente está
   * definidia y es un string. */
  if (cfg.url != null && typeof ImsRootPath === "string") {
    cfg.url = ImsRootPath + cfg.url;
  } else {
    /* Caso raro, vamos a comprobar que no sea problema de ImsRootPaht y sacar
     * un warning de ser así. Todos los casos deberían corregirse antes de
     * llegar a producción */
    if (typeof ImsRootPath !== "string") {
      /* Aquí sí lo quiero sacar. */
      // eslint-disable-next-line no-console
      console.warn(`ImsRootPath is ${typeof ImsRootPath}`);
    }
  }

  /* Tratar cabeceras de usuario, se envían en el caso de la B2B. */
  const userToken = getUserToken();
  if (userToken != null) {
    if (cfg.headers == null) {
      cfg.headers = {};
    }
    cfg.headers[WebKeys.USER_TOKEN_HEADER] = userToken;
  }

  $.ajax(cfg);
}

/**
 * Realiza una petición ajax según la configuración indicada. Si no se indica
 * cabecera se añadirá "application/json" y, excepto si los datos ya son un
 * string, se convertirá el objeto enviado a su representación JSON.
 *
 * La url indicada en la configuración debe ser relativa, ya que este método
 * añadirá la parte del contexto automáticamente.
 *
 * Si no se indica lo contrario en la configuración, la petición se realizará
 * de forma asíncrona utilizando el método POST.
 *
 * En caso de que exista información de un usuario registrado, entonces se
 * enviará también la cabecera de autenticación correspondiente.
 *
 * @param ajaxSettings la configuración de la petición
 */
export function sendAsJson(ajaxSettings: JQueryAjaxSettings): void {
  // TODO: En vez del header, no debería ser mejor "contentType: 'application/json; charset=utf-8'" ¿?
  const cfg = $.extend({}, { headers: { "Content-Type": "application/json" } }, ajaxSettings);

  if (cfg.data != null && typeof cfg.data !== "string") {
    cfg.data = JSON.stringify(cfg.data);
  }

  send(cfg);
}
